import { render, staticRenderFns } from "./PudongPatent.vue?vue&type=template&id=2c6ef56e"
import script from "./PudongPatent.vue?vue&type=script&lang=js"
export * from "./PudongPatent.vue?vue&type=script&lang=js"
import style0 from "./PudongPatent.vue?vue&type=style&index=0&id=2c6ef56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports